// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7275":"271e74f4","9997":"271e74f4"}[chunkId] + ".chunk.css";
};